<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1"></a>Spanish Warships<br/><span class="fonts"><em class="italic">in the Age of Sail</em><br/>1700–1860</span></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Haltitle.vue?d4e6a574